module.exports = __webpack_public_path__ + "2b1b006a217bf19a9574474ee92e9195.pdf";